import React, { useCallback, useEffect, useState } from "react";
import styles from "./Footer.module.scss";
import classNames from "classnames/bind";
import Button from "../Button/Button";
import * as apis from "../../apis";
import { useNavigate } from "react-router-dom";

const cx = classNames.bind(styles);

export default function Footer({ data }) {
  const navigate = useNavigate();

  const [companyInfo, setCompanyInfo] = useState({});

  const handleMove = useCallback(
    (path) => {
      navigate(path);
    },
    [navigate],
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apis.getCompanyInfo();
        setCompanyInfo(res?.data?.value);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div className={cx("container")}>
        <div className={cx("inner")}>
          <div className={cx("bottom-inner")}>
            <div className={cx("left-box")}>
              <div className={cx("logo-box")}>
                <img className={cx("logo")} src="/images/logo.png" alt="logo" />
              </div>
              <p className={`${cx("text")} font-play`}>
                상호명 : {companyInfo?.brandName}
              </p>
              <p className={`${cx("text")} font-play`}>
                대표자 : {companyInfo?.ceoName}
              </p>
              <p className={`${cx("text")} font-play`}>
                주소 : {companyInfo?.businessAddress}
              </p>
              <p className={`${cx("text")} font-play`}>
                개인정보보호책임자 : {companyInfo?.privacyOfficerName}
              </p>
              <p className={`${cx("text")} font-play`}>
                통신판매업 : {companyInfo?.onlineSellingRegNumber}
              </p>
              <p className={`${cx("text")} font-play`}>
                사업자 등록번호 : {companyInfo?.businessRegNumber}
              </p>
              <p className={`${cx("text")} font-play`}>
                고객센터 번호 : {companyInfo?.phone}
              </p>
              <p className={`${cx("text")} font-play`}>
                고객센터 이메일 : {companyInfo?.customerServiceEmail}
              </p>
            </div>
            <div className={cx("right-box")}>
              <p className={`${cx("button-text")} font-play-700`}>
                The perfect shoes for your feet, at xinvana.
              </p>
              <Button data={data} />
            </div>
          </div>
          <div className={cx("bottom-hr")} />
          <div className={cx("bottom-inner")}>
            <div className={cx("left-box")}>
              <p className={`${cx("company-name")} font-play`}>
                © 2025{" "}
                <b className={`${cx("company-name-b")} font-play-700`}>
                  xinvana.
                </b>{" "}
                All rights reserved.
              </p>
            </div>
            <div className={cx("right-box")}>
              <div className={cx("button-box")}>
                <button
                  onClick={() => handleMove("/privacy-policy")}
                  className={`${cx("button")} font-play-700`}
                >
                  Privacy Policy
                </button>
                <button
                  onClick={() => handleMove("/terms-of-service")}
                  className={`${cx("button")} font-play-700`}
                >
                  Terms of Service
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
